<template>
  <div class="">
    <div class="w-full h-full fixed left-0 top-0 bg-white bg-opacity-50 z-50" v-if="isLoading">
      <loader :label="$t('frontend_loading')" />
    </div>
    <confirm-modal ref="deleteModal" name="delete-post" :callback="confirmDelete"
      :button-text="this.$t('frontend_delete')"></confirm-modal>
    <portal to="headerContent">
      <gd-button class="w-auto h-10 mr-3 px-6" @click="importPost">{{ $t('frontend_grooveblog_blog_listing_import_posts')
      }}</gd-button>
      <gd-button class="w-auto h-10 px-6" variant="primary" @click="addPost">{{ $t('frontend_grooveblog_new_post')
      }}</gd-button>
    </portal>
    <div class="flex justify-between mt-2 mb-3">
      <div class="flex">
        <gd-dropdown :options="categoryList" class="w-48 mr-5" :placeholder="$t('frontend_all_categories')"
          v-model="selectedCategoryName" @change="searchPost"></gd-dropdown>
        <gd-dropdown :options="publishList" class="w-48" :placeholder="$t('frontend_grooveblog_last_published')"
          v-model="selectedPubish" @change="searchPost"></gd-dropdown>
      </div>
      <div>
        <text-input class="" :placeholder="$t('frontend_grooveblog_search_posts')" v-model="postFilter.name"
          @keyup="searchPost">
          <img src="@/assets/images/icons/search_query.png" slot="prependIcon" />
        </text-input>
      </div>
    </div>

    <div class="flex flex-wrap" v-if="posts.length">
      <div class="w-3/12 p-2" v-for="postList in posts" :key="postList.id">
        <div class="bg-white border rounded-md border-grey-1 h-full">
          <div class="relative border-b border-grey-1" style="height: 185px">
            <img class="w-full h-full object-cover rounded-t-md" :src="postList.post_image ||
              require('../../assets/images/theme/default-post-img.jpg')
              " />
            <div
              class="absolute top-0 left-0 w-full h-full
               panel-bg-transparent opacity-0 hover:opacity-100
               flex items-center justify-center rounded-t-md">
              <gd-button variant="primary" size="auto" class="px-5 h-10" @click="editPost(postList.id)">{{
                $t('frontend_grooveblog_open_editor') }}</gd-button>
            </div>
          </div>
          <div class="w-full flex flex-col justify-between p-4">
            <div class="flex">
              <div class="text-dark text-base font-bold flex-1" style="min-height: 40px">
                {{ postList.title }}
              </div>
              <div class="text-sm">
                <drop-menu :menu-items="getMenuItems(postList)" small :smallIcon="true" dropMenuClass="" variant="base"></drop-menu>
              </div>
            </div>
            <div class="text-primary-dark text-sm my-4 font-semibold">
              <span v-for="(category, index) in postList.categories" :key="category.id">
                {{ category.name }}<span v-if="index < postList.categories.length - 1">,</span>
              </span>
            </div>
            <div class="">
              <gd-tag :variant="postList.status == 'Live' ? 'success' : postList.status == 'Draft' ? 'warning' : 'danger'"
                size="sm" class="uppercase px-3">
                {{ postList.status }}
              </gd-tag>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center" v-if="!posts.length && !isLoading">
      <!-- :empty_state_sub_heading="$t('frontend_grooveblog_no_post_added_sub_heading')" -->
      <empty-state :empty_state_heading="$t('frontend_grooveblog_no_post_added')"
        :empty_state_button_text="$t('frontend_grooveblog_new_post')" @executeDataCreation="addPost"></empty-state>
    </div>
    <ul class="mt-4 pb-4 flex flex-row justify-end VuePagination__pagination" v-if="meta.last_page > 1">
      <li class="VuePagination__pagination-item bg-white px-3 py-1 border-r border-t border-b border-grey-100 text-black no-underline paginationPrev VuePagination__pagination-item-prev-chunk disabled paginationDisabled"
       :class="{ disabled: meta.current_page === 1 }">
        <a href="javascript:void(0);" @click.prevent="getPosts(1)">&lt;&lt;</a>
      </li>
      <li class="VuePagination__pagination-item bg-white px-3 py-1 border-r border-t border-b border-grey-100 text-black no-underline paginationPrev VuePagination__pagination-item-prev-page disabled paginationDisabled"
       :class="{ disabled: meta.current_page === 1 }">
        <a href="javascript:void(0);" @click.prevent="getPosts(meta.current_page - 1)">&lt;</a>
      </li>
      <li class="VuePagination__pagination-item  px-3 py-1 border-r border-t border-b border-grey-100 text-black no-underline  text-white "
      v-for="page in meta.last_page" :key="page" :class="{ paginationActive: meta.current_page === page }">
        <a href="javascript:void(0);" @click.prevent="getPosts(page)">{{
          page
        }}</a>
      </li>
      <li class="VuePagination__pagination-item bg-white px-3 py-1 border-r border-t border-b border-grey-100 text-black no-underline paginationNext VuePagination__pagination-item-next-page "
        :class="{ disabled: meta.current_page === meta.last_page }">
        <a href="javascript:void(0);" @click.prevent="getPosts(meta.current_page + 1)">&gt;</a>
      </li>
      <li class="VuePagination__pagination-item bg-white px-3 py-1 border-r border-t border-b border-grey-100 text-black no-underline paginationNext VuePagination__pagination-item-next-chunk disabled paginationDisabled"
        :class="{ disabled: meta.current_page === meta.last_page }">
        <a href="javascript:void(0);" @click.prevent="getPosts(meta.last_page)">&gt;&gt;</a>
      </li>
    </ul>
    <gd-modal name="share-post-modal" width="800px">
      <div class="flex flex-row w-full justify-between pt-8 px-8">
        <div class="text-xl text-grey-700 font-bold h-full flex flex-col justify-center">
          {{ $t('frontend_sites_share_links') }}
        </div>
        <div class="flex flex-row justify-end">
          <gd-button class="mr-2" variant="outline" @click="() => {
            this.$root.$emit('modal-close', 'share-post-modal');
          }
            ">{{ $t('frontend_sites_integration_modal_exit') }}</gd-button>
          <gd-button @click="addShareLink()" variant="primary">{{
            $t('frontend_sites_integration_modal_add')
          }}</gd-button>
        </div>
      </div>

      <div class="flex flex-col items-center justify-center">
        <div class="flex flex-col w-full justify-center items-center py-8">
          <div v-for="link in activeLinks" :key="link.id" class="flex flex-row justify-between w-full px-8 py-2">
            <div class="flex items-center">
              <gd-button @click="copyShareUrl(fullLink(link.link))" size="icon" variant="primary"
                :title="$t('frontend_vendors_copy_affiliate_link')">
                <i class="fas fa-copy" />
              </gd-button>
              <div class="text-grey-600 ml-2">{{ fullLink(link.link) }}</div>
            </div>
            <gd-button @click="updateLinkStatus(link, 0)" variant="outline">{{
              $t('frontend_disable')
            }}</gd-button>
          </div>
        </div>

        <div v-if="inActiveLinks.length > 0"
          class="flex w-full flex-col items-center justify-center border-t border-grey-200">
          <div class="text-lg text-grey-600 font-bold w-full px-8 py-2">
            {{ $t('frontend_sites_disabled_links') }}
          </div>
          <div class="flex flex-col w-full justify-center items-center py-4">
            <div v-for="link in inActiveLinks" :key="link.id"
              class="flex flex-row justify-between w-full px-8 py-2 items-center">
              <div class="text-grey-600">{{ fullLink(link.link) }}</div>
              <div class="flex flex-row">
                <gd-button class="mr-2" @click="updateLinkStatus(link, 1)">{{
                  $t('frontend_enable')
                }}</gd-button>
                <gd-button size="icon" @click="deleteLinkStatus(link)" primary :title="$t('frontend_delete')">
                  <i class="fas fa-trash" />
                </gd-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </gd-modal>
  </div>

</template>

<script>
import Loader from '@groovepages/gd-ui-kit/components/Loader';
import EmptyState from '@groovepages/gd-ui-kit/components/tables/EmptyState';
import ConfirmModal from '@groovepages/gd-ui-kit/components/ConfirmModal';
import axios from 'axios';
import themeConfig from '@/theme/themeConfig.js';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'Posts' };
  },
  components: { Loader, ConfirmModal, EmptyState },
  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      blogId: '',
      postToDelete: null,
      posts: [],
      meta: {},
      postsTableColumns: ['post_image', 'title', 'status', 'created_at', 'actions'],
      postsTableOptions: {
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        sortable: [],
        headings: {
          post_image: 'Featured Image',
          actions: '',
        },
        filterByColumn: false,
        filterable: ['title'],
        perPage: 6,
        rowClassCallback() { return 'hover:bg-grey-50 funnelRow' ;},
      },
      categories: [],
      selectedCategoryName: '',
      categoryList: [this.$t('frontend_grooveblog_category_list_all')],
      publishList: [
        this.$t('frontend_grooveblog_publish_list_older_first'),
        this.$t('frontend_grooveblog_publish_list_newer_first'),
        this.$t('frontend_grooveblog_publish_list_only_draft'),
        this.$t('frontend_grooveblog_publish_list_only_live'),
        this.$t('frontend_grooveblog_publish_list_only_scheduled')
      ],
      selectedPubish: '',
      postFilter: { name: '', category_id: '', order: '', limit: 8 },
      activeLinks: [],
      inActiveLinks: [],
      postIdShareLink: '',
    };
  },
  created() {
    this.blogId = localStorage.getItem('blog-id');
    this.getPosts();
    this.getCategories(this.blogId);
  },
  methods: {
    async getPosts(page = 1) {
      this.showLoader();
      await axios
        .post(`/blogpost/search/${this.blogId}?page=${page}`, this.postFilter)
        .then((response) => {
          this.posts = response.data.data;
          this.meta = response.data.meta;
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideLoader();
    },
    async confirmDelete() {
      this.showLoader();
      axios
        .delete(`/blog-posts/${this.postToDelete.id}`)
        .then(() => {
          const deletedPost = this.posts.map((item) => item.id).indexOf(this.postToDelete.id);
          this.posts.splice(deletedPost, 1);
          this.$root.$emit('modal-close', 'delete-post');
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideLoader();
    },
    async deletePost(post) {
      this.$refs.deleteModal.open();
      this.postToDelete = post;
    },
    addPost() {
      this.$router.push({ name: 'create_post' });
    },
    importPost() {
      this.$router.push({ name: 'import_post' });
    },
    editPost(id) {
      this.$router.push({ name: 'edit_post', params: { postId: id } });
    },
    clonePost(id) {
      this.showLoader();
      axios
        .get(`/blogpost/clone/${id}`)
        .then(() => {
          this.getPosts();
        });
    },
    getMenuItems(post) {
      return [
        {
          text: this.$t('frontend_edit'),
          callback: () => { this.editPost(post.id); },
        },
        {
          text: this.$t('frontend_grooveblog_share'),
          callback: () => { this.sharePost(post); },
        },
        {
          text: this.$t('frontend_clone'),
          callback: () => { this.clonePost(post.id); },
        },
        {
          text: this.$t('frontend_delete'),
          callback: () => { this.deletePost(post); },
        },
      ];
    },

    searchPost() {
      this.showLoader();
      if (this.selectedCategoryName !== '') {
        if (this.selectedCategoryName === this.$t('frontend_all_categories')) {
          this.postFilter.category_id = '';
        } else {
          const selectedCategory = this.categories.find(
            (category) => category.name === this.selectedCategoryName
          );
          this.postFilter.category_id = selectedCategory.id;
        }
      }
      let order = 'asc';
      let status = '';
      switch (this.selectedPubish) {
        case this.$t('frontend_grooveblog_publish_list_newer_first'):
          order = 'desc';
          break;
        case this.$t('frontend_grooveblog_publish_list_older_first'):
          order = 'asc';
          break;
        case this.$t('frontend_grooveblog_publish_list_only_draft'):
          status = '2';
          break;
        case this.$t('frontend_grooveblog_publish_list_only_live'):
          status = '1';
          break;
        case this.$t('frontend_grooveblog_publish_list_only_scheduled'):
          status = '3';
          break;
        default:
          order = 'desc';
      }
      this.postFilter.order = order;
      this.postFilter.status = status;
      this.getPosts();
    },
    async getCategories(blogId) {
      await axios
        .get(`/categories?blog_id=${blogId}`)
        .then((response) => {
          this.categories = response.data;
          for (let i = 0; i < this.categories.length; i += 1) {
            this.categoryList.push(this.categories[i].name);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /** share post functions */
    sharePost(row) {
      this.activeLinks = [];
      this.activeLinks = row.share_links.filter((link) => link.status === 1);
      this.inActiveLinks = row.share_links.filter((link) => link.status === 0);
      this.postIdShareLink = row.id;
      this.$root.$emit('modal-open', 'share-post-modal');
    },
    fullLink(link) {
      return process.env.NODE_ENV === 'development'
        ? `${window.config.grooveappsurl}/post/${link}/share`
        : `${window.config.grooveappsurl}/grooveblog/post/${link}/share`;
    },
    async addShareLink() {
      this.showLoader();
      await axios
        .post(`/blogpost/add-share-link/${this.postIdShareLink}`)
        .then((response) => {
          console.log(response);
          const linkData = response.data.data;
          const postIndex = this.posts.findIndex(
            (post) => post.id === this.postIdShareLink
          );
          this.posts[postIndex].share_links.push(response);
          this.activeLinks.push(linkData);
        });
      this.hideLoader();
    },
    copyShareUrl(link) {
      this.$copyText(link).then(
        () => { this.onCopy('Share link Copied!'); },
        () => { this.onError(); }
      );
    },
    async updateLinkStatus(row, status) {
      this.showLoader();
      await axios
        .post(`/blogpost/${this.postIdShareLink}/update-share-link/${row.id}`, {
          status,
        })
        .then((response) => {
          return response.data.data;
        });

      if (status === 1) {
        /** Make it Active */
        const linkIndex = this.inActiveLinks.findIndex(
          (link) => link.id === row.id
        );
        this.inActiveLinks.splice(linkIndex, 1);
        this.activeLinks.push(row);
      } else {
        /** Make it Inactive */
        const linkIndex = this.activeLinks.findIndex(
          (link) => link.id === row.id
        );
        this.activeLinks.splice(linkIndex, 1);
        this.inActiveLinks.push(row);
      }
      this.hideLoader();
    },
    async deleteLinkStatus(row) {
      this.showLoader();
      await axios
        .post(`/blogpost/${this.postIdShareLink}/delete-share-link/${row.id}`)
        .then(() => {
          const linkIndex = this.inActiveLinks.findIndex(
            (link) => link.id === row.id
          );
          this.inActiveLinks.splice(linkIndex, 1);
        });
      this.hideLoader();
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
  .VuePagination__pagination li {
    float: left;
    font-size: 14px;
    text-align: center;
    color: var(--brand-secondary-darker, #191d3a);
    padding: 4px;
    font-weight: 600;
    margin-left: 4px;
    line-height: 1.25;
  }
.VuePagination__pagination-item.page-item.VuePagination__pagination-item-prev-page,
  .VuePagination__pagination-item.page-item.VuePagination__pagination-item-next-page {
    cursor: pointer;
  }

  .VuePagination.row.col-md-12.justify-content-center {
    margin-top: 30px;
  }

  .VuePagination__pagination-item {
    border: none;
    background-color: transparent;
    color: var(--brand-secondary-darker, #191d3a);
  }

  .VuePagination__pagination-item .active,
  .VuePagination__pagination .paginationActive,
  .page-item.active {
    border-radius: 6px;
    background-color: var(--brand-primary, #fd6481);
    color: #ffffff;
  }

  .VuePagination__pagination li a,
  .VuePagination__pagination li a.active {
    padding: 3px 4px;
  }

  .VuePagination__pagination-item.page-item.VuePagination__pagination-item-prev-chunk,
  .VuePagination__pagination-item.paginationPrev.VuePagination__pagination-item-prev-chunk,
  .VuePagination__pagination-item.page-item.VuePagination__pagination-item-next-chunk,
  .VuePagination__pagination-item.paginationNext.VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination {
    .VuePagination__pagination {
      display: flex !important;
    }
  }

  .VuePagination__pagination-item.paginationPrev,
  .VuePagination__pagination-item.paginationNext {
    background: transparent;
  }

  .VuePagination {
    .paginationPrev,
    .paginationNext {
      cursor: pointer;
    }
  }

  .VuePagination {
    .paginationPrev.paginationDisabled,
    .paginationNext.paginationDisabled {
      color: #8f92ab;
      cursor: not-allowed;
    }
  }
</style>
